var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderPhenom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7644 37.9668H14.3314L12.3778 40.6157H24.0479H35.718L33.7644 37.9668Z",
    fill: "#A046D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04933 27.952C5.81413 29.6173 5.65973 31.8377 6.6376 33.6544C7.61546 35.4712 9.51972 36.6318 11.6299 36.6318H17.7029V27.952L16.7765 29.2136L13.2768 34.0077H11.6299C10.4976 34.0077 9.57119 33.4526 9.05652 32.4433C8.54186 31.4845 8.64479 30.3743 9.26239 29.4659L20.3792 14.2257V19.2721V24.2681V36.6318H23.0554V25.126V6L7.04933 27.952Z",
    fill: "#A046D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9669 27.9321L24.8995 6V25.1086V36.6041H27.6289V24.2515V19.2601V14.2182L38.7525 29.4446C39.422 30.3017 39.4735 31.411 38.9585 32.4193C38.4435 33.3773 37.4651 33.9823 36.3836 33.9823H34.7357L30.3068 27.9825V36.6545H36.3836C38.495 36.6545 40.4005 35.4949 41.3789 33.6798C42.3574 31.7639 42.1514 29.5959 40.9669 27.9321Z",
    fill: "#A046D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderPhenom);
export default __webpack_public_path__ + "static/media/loader-phenom.85b9616574c0b739e70d7f0acdad8dd7.svg";
export { ForwardRef as ReactComponent };